import { Callout, Card, Datepicker, ModalPopup, PopupDialogbox, ReactSelectBox, Search, SofturaTable, Tooltip, EventHandler } from "client/CommonComponents";
import moment from "moment";
import excel from '../../../assets/images/Excel.svg'
import completedIcon from '../../../assets/images/MyOrders/Myorder_Approved.svg'
import cancelledIcon from '../../../assets/images/MyOrders/Cancelled.svg'
import createUser from '../../../assets/images/Create User.svg'
import { useEffect, useRef } from "react";
import './Users.scss';
import AddUser from "./AddUser";
import UserAccess from "./UserAccess";
import DonloadIcon from "../../../assets/images/Download Icon.svg";
import permissions, { isAuthorized } from "client/utils/Permissions";
import ResetInventryicon from "../../../assets/images/ResetInventry.svg";
import Adduserbycostcentenicon from "../../../assets/images/AddUserbyCostCenter.svg"
import { CONSTANTS } from "client/utils/constants";

const CustomFilterCell = (props: any) => {
  const {
    column,
    options,
    selectUserName = {},
    selectAssessmentTitle = {},
    selectScore = {},
    selectModules = {},
    selectCostCenter = {},
    selectStatus = {},
    selectHomeCostCenter = {},
    handleClearSelectFilter,
    handleUpdateFilter,
  } = props;
  const optionsExt = options;

  const getValue = () => {
    if (column.key === "userName") {
      return selectUserName;
    }
    else if (column.key === "costcenter") {
      return selectCostCenter;
    }
    else if (column.key === "moduleNames") {
      return selectModules;
    }
    else if (column.key === "AssessmentTitle") {
      return selectAssessmentTitle;
    }
    else if (column.key === "latestScore") {
      return selectScore;
    }
    else if (column.key === "homeCostcenter") {
      return selectHomeCostCenter;
    } else {
      return selectStatus
    }
  }

  const getDropDownValue = () => {
    let optionArr: any = []
    if (optionsExt) {
      optionsExt?.map((item: any) => (
        optionArr.push({ key: item?.value, value: item?.value, label: item?.label })
      ))
    } else {
      optionArr = [{ label: CONSTANTS.SELECT, text: CONSTANTS.SELECT }]
    }
    return (optionArr)
  }

  return (
    <div className="date-filter-wrapper">
      <Tooltip content={getValue()?.current} data-attribute="Users_Default_Tooltip">
        <ReactSelectBox
          placeholder={CONSTANTS.SELECT}
          name={column?.key}
          onChange={(e: any) => handleUpdateFilter(e, getValue(), column?.key)}
          className="form-control"
          value={getValue()?.current ? { label: getValue()?.current, text: getValue()?.current } : { label: CONSTANTS.SELECT, text: CONSTANTS.SELECT }}
          options={getDropDownValue()}
          isSearchable={true}
         data-attribute="Users_Default_SearchSelectBox" />
      </Tooltip>
      <EventHandler onEvent={() => handleClearSelectFilter(getValue(), column?.key, "")} data-attribute="Users_Default_EventHandler">
        <i
          className="fa fa-times-circle-o"
          aria-hidden="true"
        ></i>
      </EventHandler>
    </div>
  );
};

const UpdateDateFilterCell = (updateDateData: any) => {
  const { UpdatedDate, handleUpdatedDateFilter, handleClearUpdatedDateFilter, column } = updateDateData;
  return (
    <div className="date-filter-wrapper">
      <Datepicker
        placeholder="Select"
        value={UpdatedDate.current}
        onChangeDate={(date: any) =>
          handleUpdatedDateFilter(date, UpdatedDate, column?.key)
        }
       data-attribute="Users_Default_Datepicker" />
      <EventHandler onEvent={() => handleClearUpdatedDateFilter(UpdatedDate, column?.key, undefined)} data-attribute="Users_Default_EventHandler_2">
        <i
          className="fa fa-times-circle-o"
          aria-hidden="true"
        ></i>
      </EventHandler>
    </div>
  );
};

const Users = (props: any) => {
  const {
    gridData,
    rowData = {},
    searchBy,
    onChangeSearchBy,
    onClickResetAssetInventory,
    Popupcontent,
    popupPrimarybtnOnclick,
    donwloadPrevYearResults,
    paginationData,
    setGridFilters,
    totalRecords,
    fetchAction,
    pagesCount,
    filters,
    handleUpdateFilter,
    handleClearFilter,
    usersCostCentersList,
    usersHomeCostCentersList,
    usersLatestScoresList,
    modulesList,
    onExportExcel,
    collapse,
    getUserAttempts,
    userAttemptsById,
    closeCallout,
    onClickAddUserByCostCenter,
    onSearchUser,
    onClickBranchAdminAccess,
    userData,
    setIsClearValue,
    isClearValue,
    setChangedArr,
    changedArr,
    onSubmitUserAccess,
    val,
    setShowUserAccessPopup,
    filterObj
  } = props

  const UpdatedDate = useRef(null);
  const Modules = useRef<any>(null);
  const CostCenter = useRef<any>(null);
  const Score = useRef<any>(null);
  const Status = useRef<any>(null);
  const HomeCostCenter = useRef<any>(null);

  const selectScore = useRef("");
  const selectStatus = useRef("");
  const selectModules = useRef("");
  const selectCostCenter = useRef("");
  const selectHomeCostCenter = useRef("");

  const createOptions = (data: any) => {
    return data.map((item: any) => ({ label: item.text, value: item.value }))
  }

  useEffect(() => {
    if (gridData?.length) {
      Status.current = [{ label: '-', value: '-' }, { label: 'Pass', value: 'pass' }, { label: 'Fail', value: 'fail' }]
    }
  }, [gridData])

  useEffect(() => {
    if (usersCostCentersList?.length) {
      CostCenter.current = createOptions(usersCostCentersList)
    }
  }, [usersCostCentersList])

  useEffect(() => {
  if (modulesList?.length) {
      Modules.current = createOptions(modulesList);
  }
}, [modulesList]);

  useEffect(() => {
    if (usersHomeCostCentersList?.length) {
      HomeCostCenter.current = createOptions(usersHomeCostCentersList)
    }
  }, [usersHomeCostCentersList])

  useEffect(() => {
    if (usersLatestScoresList?.length) {
      Score.current = createOptions(usersLatestScoresList)
    }
  }, [usersLatestScoresList])

  const questionColumn = [
    {
      key: "Action",
      title: "Action",
      width: 60,
      Cell: (row: any) => props?.CustomCell(row?.rowData),
      style: { textAlign: 'center' },
      id: 'action-column'
    },
    {
      key: "fullName",
      title: "User Name",
      width: 100,
      filterRowValue: filters?.fullName ?? ''
    },
    {
      key: "employeeId",
      title: "Employee ID#",
      width: 100,
      filterRowValue: filters?.employeeId ?? ''
    },
    {
      key: "costcenter",
      title: "Cost Center",
      width: 120,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          options={CostCenter.current}
          selectCostCenter={selectCostCenter}
          handleClearSelectFilter={handleClearFilter}
          handleUpdateFilter={handleUpdateFilter}
        />
      ),
    },
    {
      key: "homeCostcenter",
      title: "Home Cost Center",
      width: 120,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          options={HomeCostCenter.current}
          selectHomeCostCenter={selectHomeCostCenter}
          handleClearSelectFilter={handleClearFilter}
          handleUpdateFilter={handleUpdateFilter}
        />
      ),
    },
    {
      key: "moduleNames",
      title: "Modules",
      width: 240,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          options={Modules.current}
          selectModules={selectModules}
          handleClearSelectFilter={handleClearFilter}
          handleUpdateFilter={handleUpdateFilter}
        />
      ),
    },
    {
      key: "attemptsCount",
      title: "Assessment Attempt",
      width: 95,
      Cell: (row: any) => {
        return (
          <div className="commentBlock" id={`user_${row?.rowData?.employeeId}`}>
            {row?.rowData?.attemptsCount ? (
              <EventHandler onEvent={() => getUserAttempts(row?.rowData?.userId, `user_${row?.rowData?.employeeId}`)} data-attribute="Users_Default_EventHandler_3">
                <a>{row.rowData?.attemptsCount}</a>
              </EventHandler>
            ) : 0}
          </div>
        );
      },
      filterRowValue: filters?.attemptsCount ?? ''
    },
    {
      key: "latestScore",
      title: "Latest Score (%)",
      width: 80,
      Cell: (row: any) => `${row.rowData.latestScore}%`,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          options={Score.current}
          selectScore={selectScore}
          handleClearSelectFilter={handleClearFilter}
          handleUpdateFilter={handleUpdateFilter}
        />
      )
    },
    {
      key: "updatedDate",
      title: "Updated Date",
      width: 100,
      FilterCell: (updatedDateProps: any) => {
        return <UpdateDateFilterCell
          {...updatedDateProps}
          UpdatedDate={UpdatedDate}
          handleUpdatedDateFilter={handleUpdateFilter}
          handleClearUpdatedDateFilter={handleClearFilter}
        />;
      },
    },
    {
      key: "latestStatus",
      title: "Latest Status",
      width: 70,
      Cell: (row: any) => {
        let status;
        if (row.rowData.latestStatus === 'Fail') {
          status = <img src={cancelledIcon}
            alt='Status Icon'
            title={row.rowData.latestStatus}
            className="me-1" />
        } else if (row.rowData.latestStatus === 'Pass') {
          status = <img src={completedIcon}
            alt='Status Icon'
            title={row.rowData.latestStatus}
            className="me-1" />
        } else {
          status = ''
        }

        return (
          <p>
            {status}
            {row.rowData.latestStatus || '-'}
          </p>
        )
      },
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          options={Status.current}
          selectStatus={selectStatus}
          handleClearSelectFilter={handleClearFilter}
          handleUpdateFilter={handleUpdateFilter}
        />
      ),
    },
  ]

  const commentsTooltipProps: any = () => {
    return (
      userAttemptsById?.assessmentResultDetails?.map((item: any) => {
        return (
          <div className="AssesstAttemp-Block" key={item?.assessmentTitle}>
            <p className="counts">{item?.assessmentTitle}</p>
            {item?.userAssessmentResult?.map((result: any, index: number) => {
              return <>
                <div key={result?.assessmentResultID}>
                  <p className="counts">{(item?.userAssessmentResult?.length - index) + ' out of ' + item?.userAssessmentResult?.length}</p>
                  <span>{result?.status} | {`${result?.score}%`}</span>
                </div>
                <p className="dates">{moment(result?.assessmentDate).format('MM/DD/YYYY')}</p>
              </>
            })}
          </div>
        )
      })
    )
  }


  return (
    <div className='user-assessment CustomerMyOrder mt-1'>
      <div className='breadcrumb-toolbar users-actions'>
              <div className="left-side-btn">
                  {(isAuthorized(permissions.Assign_Users) || isAuthorized(permissions.View_Users)) && (
          <div className='create-new-order-btn mb-3 me-2 pointer' title='' >
            <EventHandler onEvent={props.AddUserClick} data-attribute="Users_Default_EventHandler_4">
              <a>
                <img src={createUser} alt='btn-icon' /><span>Add User</span>
              </a>
            </EventHandler>
                      </div>
                  )}
          {(isAuthorized(permissions.Assign_Users) || isAuthorized(permissions.View_Users)) ?
            <div className='create-new-order-btn mb-3 me-2 pointer' title='' >
              <EventHandler onEvent={(e: any) => onClickAddUserByCostCenter(e)} data-attribute="Users_Default_EventHandler_5">
                <a>
                  <span><img src={Adduserbycostcentenicon} alt="Adduserbycostcentenicon" className="ResetInventryicon" /></span><span>Add User By Cost Center</span>
                </a>
              </EventHandler>
            </div>
            : null}
          {/* Hide Reset Asset Inventory for view-only users */}
          {isAuthorized(permissions.Reset_Training) ?
            <div className='create-new-order-btn mb-3 me-2 pointer' title='' >
              <EventHandler onEvent={(e: any) => onClickResetAssetInventory(e)} data-attribute="Users_Default_EventHandler_6">
                <a>
                  <span><img src={ResetInventryicon} alt="Reset-icon" className="ResetInventryicon" /></span><span>Reset Asset Inventory</span>
                </a>
              </EventHandler>
            </div> : null}
          {isAuthorized(permissions.View_Branch_Admin_CostCenter) ?
            <div className='create-new-order-btn mb-3 me-2 pointer' title='Branch Admin Access' >
              <EventHandler onEvent={(e: any) => onClickBranchAdminAccess(e)} data-attribute="Users_Default_EventHandler_7">
                <a>
                  <span><img src={createUser} alt="Reset-icon" className="ResetInventryicon" /></span><span>Branch Admin Access</span>
                </a>
              </EventHandler>
            </div> : null}
        </div>
        {(isAuthorized(permissions.ExportPreviousYearUserReports) || isAuthorized(permissions.ViewUserReports)) ?
          <div className='mb-3 me-2 pointer' title='Download Previous Year Asset Inventory User Results'>
            <EventHandler onEvent={donwloadPrevYearResults} data-attribute="Users_Default_EventHandler_8">
              <a>
                <img src={DonloadIcon} alt='btn-icon' /><span className="DownloadText"><strong> Previous Year Asset Inventory User</strong></span>
              </a>
            </EventHandler>
          </div> : null}
      </div>
      <Card data-attribute="Users_Default_Card">
        <div className='create-new-order-container'>
          <div className='grid-block pt-2'>
            <div className='mb-1 top-section'>
              <p className='mt-1'>USER LIST</p>
              <div className='clearfix mt-2'>
                <div className='pull-left searchblock'>
                  <Search
                    placeholder='Search By User Name, Modules'
                    className='searchTextbox'
                    onSearch={(e?: any) => onSearchUser(e, true)}
                    onBlur={(e?: any) => onSearchUser(e, false)}
                    onChange={(e?: any) => onSearchUser(e, false)}
                    value={props.myUsersearchBoxValue}
                   data-attribute="Users_Default_Searchbox" />
                </div>
                {isAuthorized(permissions.ExportCurrentYearUserReports) ? <div className='pull-right datepickerControl mb-4 mb-sm-0 mt-sm-0 mt-0 pt-sm-0 pt-2'>
                  Current Year Export
                  <div className='excel-section pointer'>
                    <img src={excel} alt='excel' onClick={onExportExcel} />
                  </div>
                </div> : null}
              </div>
            </div>
            <div className={`${gridData?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
              <SofturaTable
                data={gridData ?? []}
                columns={questionColumn}
                sort={true}
                defaultPageSize={paginationData?.pageSize ?? 10}
                pageSizes={[10, 20, 50]}
                globalSearch={false}
                filter={true}
                getFilterValue={setGridFilters}
                serverTotal={totalRecords}
                fetchAction={fetchAction}
                isServerSide={true}
                pagesCount={pagesCount}
                defaultPaginationPosition='Both'
                fixedHeader={true}
               data-attribute="Users_Default_Grid" />
              {collapse?.state &&
                <Callout
                  targetId={collapse?.index}
                  calloutMaxHeight={300}
                  toggleIsCalloutVisible={closeCallout}
                 data-attribute="Users_Default_Callout">
                  {commentsTooltipProps()}

                </Callout>
              }
            </div>
          </div>
        </div>
      </Card>
      {
        props?.showAddUserPopup ?
          <ModalPopup
            ShowModalPopupFooter={true}
            ModalPopupTitle="ADD USER"
            ModalPopupType="medium"
            closeModalPopup={props?.hidePopup}
            ModalPopupName='useraccess-popup'
            FooterPrimaryBtnTxt='Add'
            FooterSecondaryBtnTxt='Cancel'
            PrimaryBtnOnclick={props?.addUser}
            SecondryBtnOnclick={props?.hidePopup}
            isFooterPrimaryBtnDisable ={!isAuthorized(permissions.Assign_Users)}
           data-attribute="Users_Default_ModalPopup">
            <AddUser
              hidePopup={props?.hidePopup}
              usersOption={props.usersOption}
              userDetails={props.userDetails}
              onChangeUserName={props.onChangeUserName}
              filterOptionUser={props.filterOptionUser}
              userSelectOnBlur={props.userSelectOnBlur}
              userSearchText={props.userSearchText}
              userById={props.userById}
              userCreated={props.userCreated}
              searchBy={searchBy}
              onChangeSearchBy={onChangeSearchBy}
            />
          </ModalPopup> : ''
      }
      {
        props?.showUserAccessPopup ?
          <ModalPopup
            ShowModalPopupFooter={true}
            ModalPopupTitle="USER ACCESS"
            ModalPopupType="medium"
            closeModalPopup={props?.UserAccesshidePopup}
            ModalPopupName='useraccess-popup'
            FooterPrimaryBtnTxt='Submit'
            FooterSecondaryBtnTxt='Cancel'
            PrimaryBtnOnclick={onSubmitUserAccess}
            SecondryBtnOnclick={props?.UserAccesshidePopup}
            isFooterPrimaryBtnDisable={val?.length == 0 || !isAuthorized(permissions.Assign_Users)}
           data-attribute="Users_Default_ModalPopup_2">
            <UserAccess
              rowData={rowData}
              userUpdated={props.userUpdated}
              userData={userData}
              setIsClearValue={setIsClearValue}
              isClearValue={isClearValue}
              setChangedArr={setChangedArr}
              changedArr={changedArr}
              setShowUserAccessPopup={setShowUserAccessPopup}
              filterObj = {filterObj}
            />
          </ModalPopup> : ''
      }
      {Popupcontent.isDialogVisible ? <PopupDialogbox
        hideDialog={!Popupcontent.isDialogVisible}
        onDismiss={Popupcontent.popupOutlinebtnOnclick}
        Popupcontent={Popupcontent}
        popupOutlinebtnOnclick={Popupcontent.popupOutlinebtnOnclick}
        popupPrimarybtnOnclick={(
          item: any,
          actionby: string,
          value: any
        ) => {
          popupPrimarybtnOnclick(
            item,
            actionby,
            value
          );
        }}
       data-attribute="Users_Default_PopupDilalogBox" /> : ""}
    </div>
  )
}

export default Users;
